import { useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { FiCheckCircle, FiXCircle, FiInfo } from "react-icons/fi";
import useToastStore from "../store/useToastStore";

const Toast = () => {
  const { message, type, isVisible, hideToast } = useToastStore();

  // Custom notification content
  const customToast = (
    message: string,
    icon: React.ReactNode,
    bgColor: string
  ) => {
    return toast(
      (t) => (
        <div
          className={`flex items-center space-x-2 p-4 rounded-md shadow-md ${bgColor}`}
        >
          {icon}
          <span className="flex-1 text-white">{message}</span>
          <button
            onClick={() => toast.dismiss(t.id)}
            className="text-white font-bold"
          >
            ✕
          </button>
        </div>
      ),
      { duration: 3000 }
    );
  };

  useEffect(() => {
    if (isVisible) {
      switch (type) {
        case "success":
          customToast(
            message,
            <FiCheckCircle className="text-green-500" size={24} />,
            "bg-green-600"
          );
          break;
        case "error":
          customToast(
            message,
            <FiXCircle className="text-red-500" size={24} />,
            "bg-red-600"
          );
          break;
        case "info":
          customToast(
            message,
           <FiInfo className="text-blue-500" size={24} />,
            "bg-blue-600"
          );
          break;
        default:
          customToast(
            message,
            <FiInfo className="text-gray-500" size={24} />,
            "bg-gray-700"
          );
      }

      // Automatically hide toast after 3 seconds
      const timeout = setTimeout(() => {
        hideToast();
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [isVisible, message, type, hideToast]);

  return (
    <Toaster
      position="bottom-right" // Position to bottom-right for user-friendliness
      toastOptions={{
        style: {
          background: "transparent",
          boxShadow: "none",
          padding: 0,
          margin: 0,
        },
      }}
    />
  );
};

export default Toast;
